import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import { darken } from '@material-ui/core/styles/colorManipulator';
import { GetThemeColorFromStorage } from '../../redux/api/themeColor';

export const CustomButton = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: 500,
    padding: '6px 16px',
    borderRadius: '4px',
    transition: 'background-color 0.3s ease',
    '&:disabled': {
      backgroundColor: 'hsl(0,0%,90%)',
      color: '#999',
    },
  },
  contained: {
    backgroundColor: (props) =>
      props?.bgColor ||
      props?.defaultColor ||
      GetThemeColorFromStorage()?.navigation?.buttons?.backgroundColor ||
      theme.palette.primary.main,
    color: '#fff',
    '&:hover': {
      backgroundColor: (props) =>
        darken(
          props?.defaultColor ||
          GetThemeColorFromStorage()?.navigation?.buttons?.backgroundColor ||
          theme.palette.primary.main,
          0.1
        ),
    },
  },


  outlined: {
    backgroundColor: (props) =>
      props?.bgColor,
    borderColor:
      (props) =>
        props?.borderColor ||
        props?.defaultColor ||
        GetThemeColorFromStorage()?.navigation?.buttons?.backgroundColor ||
        theme.palette.primary.main,
    color:
      (props) =>
        props?.defaultColor ||
        GetThemeColorFromStorage()?.navigation?.buttons?.backgroundColor ||
        theme.palette.primary.main,
    '&:hover': {
      color: '#fff',
      backgroundColor:
        (props) =>
          props?.defaultColor ||
          GetThemeColorFromStorage()?.navigation?.buttons?.hoverColor ||
          theme.palette.action.hover,
      borderColor:
        (props) =>
          props?.defaultColor ||
          GetThemeColorFromStorage()?.navigation?.buttons?.backgroundColor ||
          theme.palette.primary.main,
    },
  },


  text: {
    color:
      (props) =>
        props?.defaultColor ||
        GetThemeColorFromStorage()?.navigation?.buttons?.backgroundColor ||
        theme.palette.primary.main,
    '&:hover': {
      backgroundColor:
        (props) =>
          props?.defaultColor ||
          GetThemeColorFromStorage()?.navigation?.buttons?.hoverColor ||
          theme.palette.action.hover,
    },
  },
}))(Button);
